import { buildBentoboxApiEndpoint } from '@/apis/helpers';
import { BentoStreamRoom } from '@/types/bentoStream';
import { get, getTokenFromUrl } from '@/apis';

export const getBentoStreamRoom = async (
  billId: string
): Promise<BentoStreamRoom> => {
  const url = buildBentoboxApiEndpoint(
    `/api/external/pos/bill-room?bill_id=${billId}`
  );

  const response = await get(url, {
    customConfig: { Authorization: `Token ${getTokenFromUrl()}` }
  });

  const data = response.data;

  return data as BentoStreamRoom;
};
